/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { Query_Keys } from "../../../lib/queryKeys";
import { mergeQueryKeys, getBaseQueryKey } from "../utils/queryKeyHelpers";

const policyEngineBaseKeys = mergeQueryKeys(
  getBaseQueryKey(Query_Keys.policy_engines)
);

// An update changes the row and the policy the edit modal reads back, so both
// the listing and the show query have to go stale.
const policyEngineWithShowKeys = mergeQueryKeys(
  policyEngineBaseKeys,
  getBaseQueryKey(Query_Keys.show_policy_engine)
);

// A decision changes the row it was filed against and can settle others in the
// same cycle, so the whole review reads back rather than being patched in place.
const inactivityReviewKeys = mergeQueryKeys(getBaseQueryKey(Query_Keys.inactivity_review));

export const policyEngineMutationKeyGroups = {
  create: policyEngineBaseKeys,
  archive: policyEngineBaseKeys,
  update: policyEngineWithShowKeys,
  inactivityDecisions: inactivityReviewKeys,
};
